var render = function render(){var _vm=this,_c=_vm._self._c;return _c('option',{attrs:{"disabled":"","value":"0"}},[_vm._v("--Sila Pilih--")])
}
var staticRenderFns = []

export { render, staticRenderFns }